import { datadogLogs, Site } from "@datadog/browser-logs";
import { LogType } from "@/types/dataDogLogType";

export default class DatadogLogger {
  static instance: DatadogLogger;
  private site: string;
  private clientToken: string;

  private constructor(
    clientToken: string,
    site: string,
    service: string,
    env: string
  ) {
    this.clientToken = clientToken;
    this.site = site;
    datadogLogs.init({
      clientToken,
      site: (site as Site) || ("datadoghq.com" as Site),
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service,
      env,
    });
  }

  static Initialize(
    clientToken: string,
    site: string,
    service: string,
    env: string
  ): void {
    if (!DatadogLogger.instance) {
      DatadogLogger.instance = new DatadogLogger(
        clientToken,
        site,
        service,
        env
      );
    }
  }

  static Log(
    message: string,
    context: Record<string, unknown> | undefined,
    logType?: LogType
  ): void {
    if (!logType || logType === LogType.INFO)
      return datadogLogs.logger.info(message, context);

    if (logType === LogType.ERROR)
      return datadogLogs.logger.error(message, context);

    if (logType === LogType.DEBUG)
      return datadogLogs.logger.debug(message, context);

    if (logType === LogType.WARN)
      return datadogLogs.logger.warn(message, context);
  }
}
